<mat-toolbar color="primary">
  <div class="s11-toolbar" style="width: 100%">
    <div>
      <button
        mat-menu-item
        [matMenuTriggerFor]="mobile"
        fxShow="true"
        fxHide.gt-sm>
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #mobile="matMenu">
        <button mat-menu-item routerLink="/home" routerLinkActive="active">
          <span class="fa fa-users fa-sm"></span> Home
        </button>
        <button mat-menu-item routerLink="/lineup" routerLinkActive="active">
          <span class="fa fa-portrait fa-sm"></span> Starting Eleven
        </button>
        <button mat-menu-item routerLink="/players" routerLinkActive="active">
          <span class="fa fa-shopping-cart fa-sm"></span> Spielerübersicht
        </button>
        <button mat-menu-item routerLink="/standings" routerLinkActive="active">
          <span class="fa fa-award fa-sm"></span> Tabelle
        </button>
        <button mat-menu-item routerLink="/prices" routerLinkActive="active">
          <span class="fa fa-trophy fa-sm"></span> Preise
        </button>
        <button mat-menu-item routerLink="/faq" routerLinkActive="active">
          <span class="fa fa-list-ol fa-sm"></span> FAQ
        </button>
        <button mat-menu-item routerLink="/privacy" routerLinkActive="active">
          <span class="fa fa-list-ol fa-sm"></span> Datenschutzrichtlinie
        </button>
        <button mat-menu-item routerLink="/profile" routerLinkActive="active">
          <span class="fas fa-user fa-sm"></span> Profil
        </button>

        @if (authStore.user()?.isAdmin === true) {
          <button mat-menu-item [matMenuTriggerFor]="admin">
            <span class="fas fa-lock fa-sm"></span> Admin
          </button>

          <mat-menu #admin="matMenu">
            <button mat-menu-item routerLink="/admin/points">Punkte</button>
            <button mat-menu-item routerLink="/admin/bets">Tipps</button>
            <button mat-menu-item routerLink="/admin/news">News</button>
          </mat-menu>
        }

        <button
          mat-menu-item
          routerLink="/home/logout"
          routerLinkActive="active">
          <span class="fas fa-sign-out-alt fa-sm"></span> Logout
        </button>
      </mat-menu>
    </div>

    <span>{{ title }}</span>

    <div class="s11-toolbar" matRipple>
      @if (this.router.url === '/lineup') {
        <button
          [disabled]="configStore.freeze()"
          (click)="saveLineup()"
          mat-icon-button>
          <mat-icon
            class="icon-display"
            aria-hidden="false"
            aria-label="Aufstellung speichern"
            fontIcon="save" />
        </button>
      }
      @if (this.router.url === '/admin/points') {
        <button (click)="toggleFreeze()" mat-icon-button>
          <mat-icon
            class="icon-display"
            aria-hidden="false"
            aria-label="Änderungen einfrieren"
            fontIcon="{{ toggleFreezeIcon() }}" />
        </button>

        <button (click)="saveMatchday()" mat-icon-button>
          <mat-icon
            class="icon-display"
            aria-hidden="false"
            aria-label="Spieltag speichern"
            fontIcon="save" />
        </button>
      }
      @if (this.router.url === '/admin/bets') {
        <!-- <button (click)="saveResult()" mat-icon-button>
        <mat-icon
          class="icon-display"
          aria-hidden="false"
          aria-label="Ergebnis speichern"
          fontIcon="save" />
      </button> -->
      }

      <s11-profile-menu-icon></s11-profile-menu-icon>
    </div>
  </div>
</mat-toolbar>
